import api from './api';
import type { InventorySample } from '../types/inventory';

export interface Sample extends InventorySample {
  itemName?: string;
  itemCode?: string;
  receivedDate: string; // Mapping 'date' from InventorySample or specific field
}

export interface GetSamplesParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  receivedDate?: string;
}

export interface SamplesResponse {
  data: Sample[];
  total: number;
  page: number;
  limit: number;
}

export const getSamples = async (params: GetSamplesParams): Promise<SamplesResponse> => {
  const response = await api.get('/samples', { params });
  return response.data;
};

export const updateSampleQAStatus = async (id: string, qaPassed: boolean | null): Promise<Sample> => {
  const response = await api.put(`/samples/${id}/qa-status`, { qaPassed });
  return response.data;
};
